import convertFormData from '@module/utils/convertFormData';

import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type { ApiBaseResponse } from '../../type';
import type {
  FetchItemDetailListResponse,
  FetchItemStoreItemListResponse,
  FetchMyItemListResponse,
  GiftableItemList,
  ItemDetailParams,
  ItemPageListParams,
  ItemUseParams,
  ItemUseResponse,
  SendItemGiftParams,
  SendPushParams,
} from './type';

export const fetchItemStoreItemList = async () => {
  const res = await fetchExtended(`/v1/item/store_item_list`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();

  return result as FetchItemStoreItemListResponse;
};

export const fetchGiftableItemList = async () => {
  const res = await fetchExtended(`/v1/item/item_giftable_list`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();

  return result as GiftableItemList;
};

export const fetchItemUse = async (postUseItemParams: ItemUseParams) => {
  const res = await fetchExtended(`/v1/item/use`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(postUseItemParams),
  });

  const result = await res.json();

  return result as ItemUseResponse;
};

export const fetchMyItemList = async (fetchMyItemListParams: ItemPageListParams) => {
  const res = await fetchExtended('/v1/item/my_item_list', {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(fetchMyItemListParams),
  });

  const result = await res.json();

  return result as FetchMyItemListResponse;
};

export const fetchSendItemGift = async (params: SendItemGiftParams) => {
  const res = await fetchExtended('/v1/item/send_item_gift', {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchSendPush = async (params: SendPushParams) => {
  const res = await fetchExtended('/v1/push/send_push', {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

export const fetchItemDetail = async (params: ItemDetailParams) => {
  const res = await fetchExtended('/v1/item/item_detail', {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as FetchItemDetailListResponse;
};
